module.exports = __webpack_public_path__ + "dfc857a016786a8a47f3e6925afc5c84.jpg";